// extracted by mini-css-extract-plugin
module.exports = {"links-list__item":"LinksList_links-list__item__c7_Aj","links-list__item-link":"LinksList_links-list__item-link____J1d","no-hover":"LinksList_no-hover__kNVdv"};